import { ShowCardSkeleton } from './ShowCardSkeleton';
import './LoadingLayout.css';
import '../pages/Popular/Popular.css';

export function LoadingLayout() {
  return (
    <div className="popular-container">
      <div className="title-skeleton"></div>
      
      <div className="users-scroll-container">
        <div className="users-row">
          {Array(8).fill(0).map((_, i) => (
            <div key={i} className="user-avatar-link skeleton">
              <div className="user-avatar-skeleton"></div>
              <div className="user-name-skeleton"></div>
            </div>
          ))}
        </div>
      </div>

      <div className="friend-profile__filter-container">
        <button className="friend-profile__filter-button skeleton-filter-button">
          <span>Alla</span>
        </button>
      </div>

      <div className="shows-list">
        {Array(12).fill(0).map((_, i) => (
          <ShowCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
} 